/**
 * Chat-related constants
 */

export const MAX_CHATS = 3
export const DEFAULT_MODEL = 'gemini-3-flash-preview'
export const ABORT_MESSAGE =
  '*You aborted the streaming. Some tools might not have finished executing.*'
